<!--
 * @Author: your name
 * @Date: 2020-08-03 15:40:01
 * @LastEditTime: 2021-01-14 16:32:50
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\pages\form\widget-table\table-item-detail.vue
-->
<template>
  <div
    ref="appEngineFormDom"
    class="table-item-detail app-engine-form"
    :class="{ 'full-height': widgetConfig.readOnly }"
  >
    <form-build-render
      ref="formRender"
      :renderSence="widgetConfig.readOnly ? 'read' : 'edit'"
      :formItemList="formItemList"
      :formData.sync="formData"
      :globalData="{}"
      :formRuleConfig="formRuleConfig"
      @formEventEmit="formEventEmit"
      @scroll.native="handleScroll"
    ></form-build-render>
    <div v-if="!widgetConfig.readOnly" class="form-footer">
      <div class="form-footer-content">
        <div class="form-footer--ops">
          <x-svg-icon name="more" @click.native="handleToggle"></x-svg-icon>
          <df-collapse-transition>
            <div v-if="isShowOps" class="ops-content">
              <template v-for="ops in formOpsList">
                <div :key="ops.type" class="ops-content-item" @click="handleOpsClick(ops)">
                  <x-svg-icon :name="ops.icon"></x-svg-icon>
                  <span>{{ ops.text }}</span>
                </div>
              </template>
            </div>
          </df-collapse-transition>
        </div>
        <div class="form-footer--btns">
          <cube-button :light="true" :inline="true" :primary="true" @click="handleConfirm">
            确定
          </cube-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { RuleEngine, SimpleRuleEngine, Assert } from '@x-apaas/x-lib-rule-engine'
import {
  SET_COMP_VALUE,
  SET_COMP_PAYLOAD,
  CLEAR_COMPROUTER_STORE
} from '@/store/comp-router.store.js'
import FormBuildEngine from '@/lib/ui/components/form/form-build-engine'
import DfCollapseTransition from '@/transitions/collapse-transition/collapse-transition'
import FormDataChangeMixin from '@/mixin/form-data-change.mixin'
import ScrollBehaviorMixin from '@/mixin/scroll-behavior.mixin'
import FormRuleExecutorMixin from '@/mixin/form-rule-executor.mixin'

export default {
  name: 'TableItemDetail',
  components: {
    DfCollapseTransition
  },
  mixins: [FormDataChangeMixin, ScrollBehaviorMixin, FormRuleExecutorMixin],
  inject: ['addKeepAlive', 'removeKeepAlive'],
  provide() {
    return {
      $compRouter: {
        push: this.compRouterPush
      }
    }
  },
  data() {
    return {
      compPayloadKey: this.$route.query.key,
      formData: null,
      widgetConfig: {},
      isShowOps: false,
      formBtnList: [{ type: 'SAVE' }]
    }
  },
  computed: {
    ...mapState({
      compPayload: (state) => state.compRouterModule.compPayload,
      formConfigMap: (state) => state.formModule.formConfigMap
    }),
    formItemList() {
      if (this.widgetConfig.tableColumn) {
        const formItemList = this.widgetConfig.tableColumn.map((itemConfig) => {
          const formItemConfig = FormBuildEngine.getInstance().getComponentConfigWithType(
            itemConfig.componentType
          )
          return {
            ...formItemConfig,
            componentConfig: {
              ...formItemConfig.componentConfig,
              ...itemConfig,
              readOnly: this.widgetConfig.readOnly
            },
            // 组件校验状态，默认校验通过
            validateInfo: {
              uuid: itemConfig.uuid,
              validate: 'validate'
            }
          }
        })
        return formItemList
      } else {
        return []
      }
    },
    formOpsList() {
      const list = []
      if (!this.widgetConfig.readOnly) {
        list.push({
          type: 'DELETE',
          text: '删除',
          icon: 'form-delete'
        })
      }
      return list
    },
    computFormFields() {
      const formFields = []
      this.formItemList.forEach((item) => {
        if (item.componentConfig.componentType === 'FORM_WIDGET_TABLE') {
          formFields.push(item.componentConfig)
          item.componentConfig.tableColumn.forEach((column) => {
            formFields.push({
              tableUuid: item.componentConfig.uuid,
              ...column
            })
          })
        } else {
          formFields.push(item.componentConfig)
        }
      })
      return formFields
    },
    formId() {
      return this.$route.query.formId || this.compPayload[this.compPayloadKey].formId
    }
  },
  created() {
    this.formData = this.$lodash.cloneDeep(this.compPayload[this.compPayloadKey].value || {})
    this.setSourceDataStr(this.formData)
    this.widgetConfig = this.compPayload[this.compPayloadKey].widgetConfig
    this.registerTableFormContextMethod()
    this.initRuleTriggerDeps()
    this.triggerRule()
  },
  activated() {
    this.registerFormContextMethod()
    this.registerTableFormContextMethod()
    if (this.compPayload) {
      this.removeKeepAlive(this.$options.name)
      this.$set(
        this.formData,
        this.compPayload.activeKey,
        this.compPayload[this.compPayload.activeKey] &&
          this.compPayload[this.compPayload.activeKey].value
      )
      this.formData = { ...this.formData }
      this.setSourceDataStr(this.formData)
      this.clearCompRoterStore(this.compPayload.activeKey)
      this.triggerRule()
    }
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompValue: SET_COMP_VALUE,
      setCompPayload: SET_COMP_PAYLOAD,
      clearCompRoterStore: CLEAR_COMPROUTER_STORE
    }),
    handleToggle() {
      this.isShowOps = !this.isShowOps
    },
    handleOpsClick(ops) {
      if (ops.type === 'DELETE') {
        this.$confirm({
          message: '删除数据后不可恢复，是否确定删除？',
          okConfig: {
            onOk: () => {
              this.$set(this.formData, '$deleted', true)
              this.setCompValue({
                key: this.$route.query.key,
                value: this.$lodash.cloneDeep(this.formData)
              })
              this.sourceDataStr = JSON.stringify(this.formData)
              this.$router.go(-1)
            }
          },
          cancelConfig: {
            onCancel: () => {}
          }
        })
      }
    },
    handleConfirm() {
      this.$refs.formRender.validate((validate, error) => {
        if (validate) {
          this.setCompValue({
            key: this.$route.query.key,
            value: this.$lodash.cloneDeep(this.formData)
          })
          this.sourceDataStr = JSON.stringify(this.formData)
          this.$router.go(-1)
        } else {
          this.scrollToError()
        }
      })
    },
    scrollToError() {
      setTimeout(() => {
        const isError = this.$refs.appEngineFormDom.getElementsByClassName('is-error')
        const dom = isError[0].parentElement
        dom.scrollIntoView({
          // 滚动到指定节点
          block: 'start', // 值有start,center,end，nearest，当前显示在视图区域开始
          behavior: 'smooth' // 值有auto、instant,smooth，缓动动画（当前是慢速的）
        })
      }, 100)
    },
    formEventEmit($event) {
      this.ruleTriggerParams = { ...$event }
      this.debounceExecuteRuleEngine(
        this.formConfigMap[this.formId].xdapFormConfig.detailPage &&
          this.formConfigMap[this.formId].xdapFormConfig.detailPage.formRule
      )
    },
    compRouterPush(compName, compPayload) {
      this.setCompPayload(compPayload) // key widgetConfig value
      this.addKeepAlive(this.$options.name)
      this.$nextTick(() => {
        this.$router.push({
          name: compName,
          params: {
            id: 'all'
          },
          query: {
            appId: this.$route.query.appId,
            key: compPayload.key,
            formId: this.formId,
            documentId: this.$route.query.documentId,
            inTable: compPayload.inTable,
            tableUUID: compPayload.tableUUID
          }
        })
      })
    },
    initRuleTriggerDeps() {
      const formRule = this.formConfigMap[this.formId].xdapFormConfig.detailPage.formRule
      const ruleTriggerDeps = {}
      this.ruleTriggerDeps = ruleTriggerDeps
      Object.keys(formRule).forEach((itemUuid) => {
        const itemRule = formRule[itemUuid]
        Object.keys(itemRule).forEach((type) => {
          const itemTypeRule = itemRule[type]
          if (itemTypeRule.ruleType === 'simple') {
            // 解析简单规则依赖
            const simpleRuleConfig = itemTypeRule.simpleRuleConfig
            const formFieldRuleList = simpleRuleConfig.formFieldRuleList
            formFieldRuleList.forEach((formFieldRule) => {
              formFieldRule.fieldRuleList.forEach((fieldRule) => {
                if (ruleTriggerDeps[itemUuid]) {
                  ruleTriggerDeps[itemUuid].add(fieldRule.uuid)
                } else {
                  ruleTriggerDeps[itemUuid] = new Set()
                  ruleTriggerDeps[itemUuid].add(fieldRule.uuid)
                }
              })
            })
          } else if (itemTypeRule.ruleType === 'advanced') {
            // 解析高级规则依赖
            const advancedRuleConfig = itemTypeRule.advancedRuleConfig
            advancedRuleConfig.advancedRuleList.forEach((advancedRule) => {
              if (advancedRule.ruleType === 'COMPONENT_VALUE') {
                if (ruleTriggerDeps[itemUuid]) {
                  ruleTriggerDeps[itemUuid].add(advancedRule.value)
                } else {
                  ruleTriggerDeps[itemUuid] = new Set()
                  ruleTriggerDeps[itemUuid].add(advancedRule.value)
                }
              }
            })
          }
        })
      })
    },
    triggerRule() {
      Object.keys(this.ruleTriggerDeps).forEach((depsUuid) => {
        // 从组建中获取值
        // 触发单中的数据
        this.ruleTriggerDeps[depsUuid].forEach((depUuid) => {
          this.ruleTriggerParams = {
            event: this.formData[depUuid],
            eventName: 'change',
            propKey: depUuid
          }
          // depsUuid
          this.executeRuleFunction(
            this.formConfigMap[this.formId].xdapFormConfig.detailPage.formRule
          )
        })
      })
    },
    registerTableFormContextMethod() {
      const getComponentValueFunction = {
        name: 'getComponentValue',
        mockFunction: (...args) => {},
        executeFunction: (...args) => {
          if (args[0]) {
            const arr = args[0].split('.')
            arr[0] = arr[1]
            const compConfig = this.computFormFields.find((item) => {
              return item.uuid === arr[0]
            })
            if (compConfig) {
              if (compConfig.componentType === 'FORM_MONEY_INPUT') {
                return this.formData[arr[0]] ? Number(this.formData[arr[0]]) : this.formData[arr[0]]
              } else if (compConfig.componentType === 'FORM_DEPARTMENT_SELECT') {
                return (
                  this.formData[arr[0]] && this.formData[arr[0]].map((item) => item.id).join(',')
                )
              } else if (compConfig.componentType === 'FORM_PEOPLE_SELECT') {
                return (
                  this.formData[arr[0]] && this.formData[arr[0]].map((item) => item.id).join(',')
                )
              } else {
                return this.formData[arr[0]]
              }
            }
          }
          return undefined
        }
      }
      const getComponentFunction = {
        name: 'getComponent',
        mockFunction: (...args) => {},
        executeFunction: (...args) => {
          args = args || arguments
          if (args[0] && args[0].includes('.')) {
            const arr = args[0].split('.')
            arr[0] = arr[1]
            const compConfig = this.computFormFields.find((item) => {
              return item.uuid === arr[0]
            })
            if (compConfig) {
              return {
                ...compConfig,
                componentValue: this.formData[arr[0]]
              }
            }
          } else {
            const uuid = args[0]
            const compConfig = this.compPayload[this.compPayloadKey].formConfigList.find((item) => {
              return item.componentConfig.uuid === uuid
            })
            if (compConfig.componentConfig) {
              return {
                ...compConfig.componentConfig,
                componentValue: this.compPayload[this.compPayloadKey].formData[uuid]
              }
            } else {
              return {
                componentValue: this.compPayload[this.compPayloadKey].formData[uuid]
              }
            }
          }
          return undefined
        }
      }
      // 高级版
      RuleEngine.getInstance().registerContextMethod(
        getComponentValueFunction.name,
        getComponentValueFunction
      )
      RuleEngine.getInstance().registerContextMethod(
        getComponentFunction.name,
        getComponentFunction
      )

      const setValueFunction = {
        name: 'xdapsetvalue',
        needComponentConfig: true,
        needYield: true,
        mockFunction: (...args) => {
          Assert.argsLength(args, 2)
        },
        executeFunction: (...args) => {
          Assert.argsLength(args, 2)
          args = args.map((arg) => {
            return typeof arg === 'object' && typeof arg.next === 'function'
              ? arg.next().value
              : arg
          })
          args[1] =
            args[1] && typeof args[1] === 'object' && args[1].componentType
              ? args[1].componentValue
              : args[1]
          this.$set(this.formData, args[0].uuid, args[1])
        }
      }
      RuleEngine.getInstance().registerContextMethod(setValueFunction.name, setValueFunction)

      // 简易版
      SimpleRuleEngine.getInstance().registerContextMethod(
        getComponentValueFunction.name,
        getComponentValueFunction
      )
      SimpleRuleEngine.getInstance().registerContextMethod(getComponentFunction.name, getComponentFunction)
    },
    handleRouteLeave(type) {
      const _this = this
      return new Promise((resolve, reject) => {
        if (type === 'SAVE') {
          _this.$confirm({
            message: '是否需要提交或保存修改?',
            okConfig: {
              onOk() {
                _this.$refs.formRender.validate((validate, error) => {
                  if (validate) {
                    _this.setCompValue({
                      key: _this.$route.query.key,
                      value: _this.$lodash.cloneDeep(_this.formData)
                    })
                    resolve()
                  } else {
                    _this.scrollToError()
                    reject(new Error(error))
                  }
                })
              }
            },
            cancelConfig: {
              onCancel() {
                resolve()
              }
            }
          })
        } else if (type === 'SUBMIT') {
        } else {
          resolve()
        }
      })
    },
    scrollToY(y) {
      this.$refs.formRender.$el.scrollTop = y
    }
  }
}
</script>

<style lang="scss">
.table-item-detail {
  .form-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: $--app-light-color;
    border-top: 1px solid $--app-body-bgColor;
    .form-footer-header {
      padding: 0.5rem;
      .form-footer-idea--textarea {
        min-height: 6.14rem;
        max-height: 6.14rem;
        &.cube-textarea-wrapper::after {
          border: 0;
        }
      }
    }
    .form-footer-content {
      display: flex;
      align-items: center;
      height: 3.428rem;
      .form-footer--ops {
        position: relative;
        display: flex;
        justify-content: flex-end;
        flex: 0 0 2.86rem;
        color: $--app-primary-color;
        margin-left: 0.57rem;
        .ops-content {
          display: flex;
          flex-direction: column;
          position: absolute;
          bottom: 100%;
          left: 0;
          width: 7rem;
          border-radius: $--app-base-border-radius;
          background-color: $--app-box-bgColor;
          z-index: 100;
          box-shadow: $--app-box-shadow;
          box-sizing: border-box;
          .ops-content-item {
            flex: 1;
            display: flex;
            align-items: center;
            height: 2.5rem;
            padding: 0.285rem;
            > span {
              font-size: $--app-base-font-size;
              flex: 1;
              margin: 0 0.285rem;
            }
          }
        }
      }
      .form-footer--btns {
        display: flex;
        justify-content: flex-end;
        flex: 1;
      }
    }
    .cube-btn {
      margin-right: 1.142rem;
      width: 4.571rem;
      height: 2.285rem;
    }
  }
  &.full-height {
    .form-build-render {
      height: 100%;
    }
  }
}
</style>
